import { BsTriangleFill } from "react-icons/bs";

const CardArrowPointer = ({style}) => {
    return (
      <BsTriangleFill
        className={"admin__home-card-arrow-pointer"}
        style={style}
      />
    );
  };

export default CardArrowPointer